import { computed, type ComputedRef } from 'vue'

interface RetryableQuery {
  readonly isError: { readonly value: boolean }
  readonly isFetching: { readonly value: boolean }
}

/** True while a refetch runs after a failure, so the error region's Try again shows busy. */
export function retrying(...queries: readonly RetryableQuery[]): ComputedRef<boolean> {
  return computed(() => queries.some((query) => query.isError.value && query.isFetching.value))
}
